var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('ul',{staticClass:"category-list clearfix"},_vm._l((_vm.list),function(item){return _c('li',{key:item.classId,staticClass:"category-item fl",class:{'is-active': _vm.current === item.classId},on:{"click":function($event){_vm.handleCateTap(item.classId)}}},[_vm._v(_vm._s(item.className))])}))}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-000e5368","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/core/categories/categories.vue
// module id = null
// module chunks = 